import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Youtube, Music2 } from 'lucide-react';

const ContactPage = () => {
  const email = 'admin@iamhethatis.com';
  return (
    <div className="min-h-screen bg-[#0D0D0D] pt-24 pb-32" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <p className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Contact</p>
        <h1 className="font-['Bebas_Neue'] text-5xl md:text-6xl tracking-wider mb-6 text-white">
          Get In Touch
        </h1>
        <p className="text-[#A3A3A3] text-lg mb-12 leading-relaxed">
          Press, business, licensing, partnerships, fan mail. The fastest way to reach me is email.
        </p>

        <div className="bg-[#1A1A1A] border border-[#262626] rounded-lg p-8 mb-10">
          <div className="flex items-center gap-4 mb-3">
            <Mail className="text-[#D4AF37]" size={24} />
            <h2 className="font-['Bebas_Neue'] text-2xl tracking-wider text-white">Email</h2>
          </div>
          <a
            href={`mailto:${email}`}
            data-testid="contact-email-link"
            className="block text-2xl text-[#D4AF37] hover:text-[#E5C048] transition-colors break-all"
          >
            {email}
          </a>
          <p className="text-sm text-[#737373] mt-3">
            I read every email personally. Expect a reply within 24-48 hours.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-12">
          <Link
            to="/advertise"
            className="block bg-[#1A1A1A] border border-[#262626] hover:border-[#D4AF37]/50 rounded-lg p-6 transition-colors"
          >
            <h3 className="text-white font-medium mb-2">Brand & Advertising</h3>
            <p className="text-sm text-[#A3A3A3]">
              Use the Advertise With Us page to book ad placements and sponsorships.
            </p>
            <p className="text-xs text-[#D4AF37] mt-3">Visit /advertise &rarr;</p>
          </Link>
          <a
            href={`mailto:${email}?subject=Licensing%20Inquiry`}
            className="block bg-[#1A1A1A] border border-[#262626] hover:border-[#D4AF37]/50 rounded-lg p-6 transition-colors"
          >
            <h3 className="text-white font-medium mb-2">Music Licensing</h3>
            <p className="text-sm text-[#A3A3A3]">
              For sync, film, TV, podcast, or commercial use of any track or beat.
            </p>
            <p className="text-xs text-[#D4AF37] mt-3">Email with subject "Licensing" &rarr;</p>
          </a>
        </div>

        <div className="border-t border-[#262626] pt-8">
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] mb-4">Find me elsewhere</p>
          <div className="flex gap-4">
            <a
              href="https://instagram.com/iamhethatis"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-[#262626] flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors text-[#A3A3A3]"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-[#262626] flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors text-[#A3A3A3]"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
            <a
              href="https://music.apple.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-[#262626] flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors text-[#A3A3A3]"
              aria-label="Music"
            >
              <Music2 size={18} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
